import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import FullPageError from '../../errorBoundary/FullPageError';
import { priorityLoader } from '../../loadable/lib/priorityLoader';
import { gate } from 'hub-http/gates';
import { useHasAllGates } from '../../auth/hooks/useHasAllGates';
import { jsx as _jsx } from "react/jsx-runtime";
export const loadTable = () => import( /* webpackChunkName: "crm-object-table" */'./IndexPageTable').then(mod => mod.default);
export const loadTableNew = () => import( /* webpackChunkName: "crm-object-table" */'./IndexPageTableNew').then(mod => mod.default);
export const lowPriorityLoadTable = priorityLoader({
  loader: () => import( /* webpackChunkName: "crm-object-table" */'./IndexPageTable').then(mod => mod.default),
  priority: 'low'
});
const LoadingComponent = () => /*#__PURE__*/_jsx(LoadingSpinner, {
  grow: true
});
const OldAsyncIndexPageTable = Loadable({
  loader: loadTable,
  LoadingComponent,
  ErrorComponent: FullPageError
});
const NewAsyncIndexPageTable = Loadable({
  loader: loadTableNew,
  LoadingComponent,
  ErrorComponent: FullPageError
});
export const AsyncIndexPageTable = () => {
  const hasAllGate = useHasAllGates();
  return hasAllGate(gate('CRM:Index:UseVizCoreLib')) ? /*#__PURE__*/_jsx(NewAsyncIndexPageTable, {}) : /*#__PURE__*/_jsx(OldAsyncIndexPageTable, {});
};